<template>
  <div class="content">
    <div class="bg">
      <div class="titleline">
        <span class="required">*</span>
        <p class="inputer">
          <input type="text" :placeholder="`请输入${$_syscfg.topic}主题`" v-model="title" maxlength="60">
          <span class="count">{{`${title.length}/60`}}</span>
        </p>
      </div>
      <div class="article">
        <span class="required">*</span>
        <textarea class="content" :placeholder="`请输入${$_syscfg.topic}正文`" v-model="content"></textarea>
      </div>
      <div class="tags">
        <span class="tag" v-for="(t, i) in tags" :key="i">
          <span>{{t.name}}</span>
          <img src="@assets/img/topics/del.svg" alt="del" @click="delTag(t)">
        </span>
        <input type="text" placeholder="请输入标签，回车添加" @keyup.enter="addTag">
      </div>
      <div class="remark">
        <textarea :placeholder="`${$_syscfg.topic}备注`" v-model="remark" maxlength="200"></textarea>
        <span class="count">
          {{`${remark.length}/200`}}
        </span>
      </div>
    </div>
    <div class="footline">
      <div class="btn" @click="create()">提交</div>
      <div class="btn gray" @click="goBack()">取消</div>
    </div>
    <successTip ref="successTip" />
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import successTip from '@components/successTip'

export default {
  name: 'newTopic',
  components: {
    successTip
  },
  data() {
    return {
      title: '',
      content: '',
      remark: '',
      tags: []
    }
  },
  methods: {
    addTag(e) {
      // 新增标签
      const v = e.target.value

      if (!v) return

      if (v.length > 8)  {
        this.$toast('标签字数不能超过8个')
        return
      }

      this.tags.push({
        name: v,
        o: this.tags.length
      })

      e.target.value = ''
    },
    delTag(t) {
      // 删除标签
      this.tags.splice(t.o, 1)
      this.reorderTags()
    },
    reorderTags() {
      // 标签删除后重新排序
      this.tags.forEach((i, d) => {
        i.o = d
      })
    },
    create() {
      // 提交创建数据
      const tags = []
      this.tags.forEach((i) => {
        tags.push(i.name)
      })

      const info = {
        title: this.title,
        content: this.content,
        tags: tags.join(','),
        remark: this.remark
      }

      common.myFetch(apis.Tpc_new, info, 'post')
      .then((data) => {
        if (data) {
          const info = {
            msg: data,
            tip: '页面即将关闭'
          }

          this.$refs.successTip.open(info)
        }
      })
    },
    goList() {
      this.$router.push({
        path: '/topics'
      })
    },
    goBack() {
      // window.history.go(-1)
      
      window.close()
    }
  }
}
</script>

<style lang="less" src="@assets/css/topic/newTopic.less" scoped></style>
